import type { CircuitVerticalMetres, HeightLeg } from "./types";

const legKey = (leg: HeightLeg): string =>
  `${leg.at.x.toFixed(2)},${leg.at.y.toFixed(2)}|${leg.fromM}|${leg.toM}`;

// A run is one cable: every rise and drop at one point between the same heights is made once.
export const circuitVerticalMetres: CircuitVerticalMetres = (profiles) => {
  const counted = new Set<string>();
  let verticalM = 0;
  let changes = 0;
  profiles.forEach(({ legs }) =>
    legs.forEach((leg) => {
      if (leg.kind === "run") return;
      // A switch's own drop and the same drop passed on the way to its lights are one cable.
      const key = legKey(leg);
      if (counted.has(key)) return;
      counted.add(key);
      verticalM += leg.lengthM;
      changes += 1;
    }),
  );
  return { verticalM, changes };
};
